const API_BASE = process.env.VUE_APP_API_BASE || 'https://shuffles88.thevixindustry.com/api'
let csrfToken = ''

export async function request(path, options = {}) {
  const method = (options.method || 'GET').toUpperCase()
  const headers = { Accept: 'application/json', ...(options.headers || {}) }
  if (options.body && !(options.body instanceof FormData)) headers['Content-Type'] = 'application/json'
  if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    if (!csrfToken) {
      try {
        const csrfRes = await fetch(`${API_BASE}/auth/csrf.php`, { credentials: 'include' })
        const csrfData = await csrfRes.json()
        csrfToken = csrfData.csrfToken || ''
      } catch (_) {}
    }
    if (csrfToken) headers['X-CSRF-Token'] = csrfToken
  }
  const res = await fetch(`${API_BASE}/${path}`, { ...options, method, headers, credentials: 'include' })
  const data = await res.json().catch(() => ({}))
  if (!res.ok || data.ok === false) throw new Error(data?.error?.message || data.message || 'Something went wrong')
  return data
}
export const api = {
  get: (p) => request(p),
  post: (p, body) => request(p, { method: 'POST', body: JSON.stringify(body) }),
  put: (p, body) => request(p, { method: 'PUT', body: JSON.stringify(body) }),
  del: (p) => request(p, { method: 'DELETE' })
}
export function resetCsrf() { csrfToken = '' }
